import { JobStatusTableComponent } from 'components/JobStatusTableComponent';
import Loading from 'components/Placeholders/Loading';
import { UploadUI } from 'components/UploadUI';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { buildBreadCrumbData, isNewUIEnabled } from 'utils/utils';
import HOME_PAGEV1 from '../HomePageV2/HomePage';
import { useLocation } from 'react-router';
import BreadCrumbsComponent from 'componentsV2/Breadcrumbs/BreadCrumbsComponent';

const HomePage = () => {
  const location = useLocation();
  const unleashDetails = useSelector(
    (state) => state.getUnleashDetails.unleashDetails
  );
  const isLoadingUnleash = useSelector(
    (state) => state.getUnleashDetails.isLoading
  );
  const error = useSelector((state) => state.getUnleashDetails.error);

  const [isLoading, setIsLoading] = React.useState(false);
  const isTableLoading = useSelector(
    (state) => state.homePage.isProcessingJobDetails
  );
  const isNewUI = useMemo(() => {
    return isNewUIEnabled(unleashDetails, error, isLoadingUnleash);
  }, [unleashDetails, error, isLoadingUnleash]);

  useEffect(() => {
    document.title = 'Digital Asset Management';
  }, []);

  return isNewUI ? (
    <HOME_PAGEV1 />
  ) : (
    <div>
      <BreadCrumbsComponent
        breadCrumbData={buildBreadCrumbData(location.pathname)}
      />
      <UploadUI setIsLoading={setIsLoading} />
      <JobStatusTableComponent />
      {(isLoading || isTableLoading || isLoadingUnleash) && <Loading />}
    </div>
  );
};

export default HomePage;
